import { Button, message } from 'antd';
import React, { useState } from 'react';
import PhotosViewer from '../../components/PhotosViewer/PhotosViewer';

interface Image {
  id: string;
  url: string;
}
function ShowImageTransferProof(props: any) {
  const [isOpen, setIsOpen] = useState(false);
  const [images, setImages] = useState([]);

  function handleClose() {
    setIsOpen(false);
  }

  function toggle() {
    let images = props.images;

    if (!images) {
      message.error('Không có ảnh');
      return;
    }

    images = images.map((image: Image) => {
      return {
        src: image.url,
        thumbnail: image.url,
        caption: `Ảnh ${image.id}`,
      };
    });

    setImages(images);
    setIsOpen(true);
  }

  return (
    <>
      <Button size="small" onClick={toggle}>
        Biên lai
      </Button>
      {isOpen && (
        <PhotosViewer
          onClose={handleClose}
          imgs={images}
          showThumbnails
          isOpen
        />
      )}
    </>
  );
}

export default ShowImageTransferProof;
